import { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { DashboardLayout } from "src/components/dashboard";
import ReferralTable from "src/components/dashboard/referralTable";
import { ReferralListProps } from "../dashboard/dashboardTypes";
import { PaginationProps } from "src/components/ui/Pagination";
import AppModal from "src/components/ui/widget/Modal/Modal";
import ModalContent from "src/components/common/ModalContent";
import { useGetReferralsQuery } from "src/store/services/dashboardApi";
import { useExportReferralQuery } from "src/store/services/adminApi";

const RerralsHistoryPage = () => {
  const [allReferrals, setAllReferrals] = useState<ReferralListProps[]>([]);
  const [showExportModal, setShowExportModal] = useState(false);
  const [paginationData, setPaginationData] = useState<PaginationProps>({
    page: 0,
    pageSize: 0,
    total: 0,
    totalPages: 0,
  });
  const [pageNo, setPageNo] = useState(1);

  // RTK Query hooks
  const { data: referralsResp } = useGetReferralsQuery({
    page: pageNo,
    limit: 10,
  });
  const [shouldExport, setShouldExport] = useState(false);
  const {
    data: exportData,
    isLoading: exportingData,
    error: exportError,
  } = useExportReferralQuery(undefined, {
    skip: !shouldExport,
  });
  useEffect(() => {
    const rows = referralsResp?.payload?.data;
    const pagination = referralsResp?.payload?.pagination;
    if (rows) setAllReferrals(rows);
    if (pagination) setPaginationData(pagination);
  }, [referralsResp]);

  useEffect(() => {
    document.title = "Referral Page";
  }, []);

  // Handle export response
  useEffect(() => {
    if (exportData && shouldExport) {
      toast.success(exportData?.message || "Export successful");
      setShowExportModal(false);
      if (exportData?.payload?.data?.fileUrl) {
        window.location.href = exportData.payload.data.fileUrl;
      }
      setShouldExport(false); // Reset trigger
    }
  }, [exportData, shouldExport]);

  // Handle export error
  useEffect(() => {
    if (exportError && shouldExport) {
      console.error("Export error:", exportError);
      const errorMessage =
        (exportError as any)?.data?.error?.message ||
        (exportError as any)?.message ||
        "Error exporting data";
      toast.error(errorMessage);
      setShouldExport(false); // Reset trigger
    }
  }, [exportError, shouldExport]);

  const dumpReferralData = () => {
    setShouldExport(true);
  };

  return (
    <DashboardLayout
      pageTitle="Referrals Leaderboard"
      rhsHeading={
        <button
          onClick={() => setShowExportModal(true)}
          className="bg-primary text-white p-3 rounded-md px-6"
        >
          Export
        </button>
      }
    >
      <ToastContainer />
      <ReferralTable
        pgn={pageNo}
        setpgn={setPageNo}
        rows={allReferrals}
        paginationData={paginationData}
      />
      <AppModal
        open={showExportModal}
        onClose={() => setShowExportModal(false)}
        content={
          <ModalContent
            content1="Export Reeferral Data"
            content2="Are you sure you want to export referral data?"
            btnAction={dumpReferralData}
            linkContent={"Yes, Please"}
            onClick={() => setShowExportModal(false)}
            loading={exportingData}
          />
        }
      />
    </DashboardLayout>
  );
};

export default RerralsHistoryPage;
